import dynamic from "next/dynamic";
import Head from "next/head";
import { useRouter } from "next/router";

import classNames from "classnames";

import CustomCard from "components/CustomCard";
import { profileUrl } from "components/ProfilePageLayout";
import { useApi } from "hooks/useApi";
import useAuthentication from "hooks/useAuthentication";

const SignUpForm = dynamic(() => import("components/SignUpForm"));

const AccountUpgradeForm = dynamic(
  () => import("components/AccountUpgradeForm")
);

const ProfilePageDiscussionsList = dynamic(
  () => import("./ProfilePageDiscussionsList")
);

type ProfilePageDiscussionsProps = {};

const ProfilePageDiscussions = ({}: ProfilePageDiscussionsProps) => {
  const router = useRouter();
  const slug = router.query.slug as string;

  const { authenticated, account } = useAuthentication();

  const isCompany = router.route.startsWith("/companies/[slug]");

  const { data: profile } = useApi(profileUrl(slug, isCompany));
  const { name, companyName } = profile || {};

  const title = `${name}${
    companyName ? ` - ${companyName}` : ""
  } - Discussions`;
  const description = "Sign up to view latest discussions on Smartkarma";

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Head>
      {authenticated ? (
        account?.isPreviewPass ? (
          <div className="md:mt-[45px]">
            <AccountUpgradeForm />
          </div>
        ) : (
          <CustomCard
            className={classNames(
              "mx-0 mt-0 rounded-none",
              "md:rounded-xl md:mt-[45px]",
              "min-h-[max(calc(100vh-480px),720px)]"
            )}
          >
            <ProfilePageDiscussionsList />
          </CustomCard>
        )
      ) : (
        <div className="md:mt-[45px] md:shadow">
          <SignUpForm
            {...(isCompany
              ? { companyId: profile?.id }
              : { accountId: profile?.id })}
            type="insight-signup"
          />
        </div>
      )}
    </>
  );
};

export default ProfilePageDiscussions;
